function analytics(eventName, data) {
  if (window) {
    window.Moengage.track_event(eventName, data);
  }
}
export { analytics };
